var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.current.matches("loading.loading"))?_c('div',[_c('loading-spinner')],1):_c('div',{staticClass:"resourceTiles"},_vm._l((_vm.tags),function(tag){return _c('tag-tile',{key:tag,attrs:{"tag":tag}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }